import { Component, Input, OnInit, OnDestroy, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ScrollService, PlatformService } from '@app/data'

@Component({
  selector: 'app-scroll-into-view',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './scroll-into-view.component.html',
  styleUrls: ['./scroll-into-view.component.less']
})
export class ScrollIntoViewComponent implements OnInit, OnDestroy {

  @Input() id!: string;

  public scrollIntoView$: BehaviorSubject<string> = this.scroll.scrollIntoView$; 
  private unsubscribe$: Subject<void> = new Subject();

  constructor(
    private host: ElementRef,
    private scroll: ScrollService,
    private platform: PlatformService
  ) {}

  ngOnInit(): void {
    this.scrollIntoView$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) =>{
      console.log('**** ScrollIntoViewComponent scrollIntoView$ res ', res);

      if (res !== '') {
        this.scrollIntoView(res);
      }
    });
  }

  ngOnDestroy(): void {

    this.unsubscribe$.next();
    this.unsubscribe$.complete();   
  }

  public scrollIntoView = (scrollIntoView: string): boolean => {
    //console.log('ScrollIntoViewComponent scroll scrollIntoView ', scrollIntoView);
    //console.log('ScrollIntoViewComponent scroll this.id ', this.id);

    if (scrollIntoView === this.id && this.platform.isBrowser) {
      this.host.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    
    return true;
  }; 
}
